import { Menu } from '@mui/icons-material';
import { Box, Grid, IconButton, Paper } from '@mui/material';

import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ContextMenu from 'app/components/ContextMenu';
import { useAuthContext } from 'utils/hooks/useAuthContext';

import AppMenu from '../Menu';
import { ShoppingCartButton } from './ShoppingCart';

interface Props {
  heading?: string;
  renderHeading: () => JSX.Element;
}

export const MobileMenuBar = ({ heading, renderHeading }: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const anchorRef = useRef(null);
  const { user, permissions } = useAuthContext();

  return (
    <Grid
      container
      className="mobile-menu"
      component={Paper}
      justifyContent="center"
      alignItems={'center'}
    >
      <IconButton ref={anchorRef} onClick={() => setMenuOpen(true)}>
        <Menu />
      </IconButton>
      <ContextMenu
        open={menuOpen}
        setOpen={setMenuOpen}
        anchorEl={anchorRef.current}
        placement="left-start"
        sx={{ overflow: 'auto', height: '100%' }}
      >
        <AppMenu mobile user={user} handleClick={() => setMenuOpen(false)} />
      </ContextMenu>
      <Box flexShrink={1}>{heading && renderHeading()}</Box>
      <Grid item xs textAlign={'right'}>
        {location.pathname.startsWith('/leihbar') && <ShoppingCartButton />}
      </Grid>
    </Grid>
  );
};
